var tri = require("tripartite"); var t = "<label>\n\t__label__\n\t<input type=\"text\" name=\"__name__\" id=\"__id__\" value=\"__value__\"\/>\n<\/label>"; 
module.exports = tri.addTemplate("webhandle-page-editor/input-template", t); 